module.exports = __webpack_public_path__ + "img/cardRequest.52a1b907.svg";